import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ar from "../../language/Ar";
import en from "../../language/En";
import { fetchPaymentList } from "../../redux/adminReducer";
import Loader from "../../common/loader";

function Payment() {
  const { lang, translations, dir } = useSelector((state) => state.language);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 10;
  const dispatch = useDispatch();

  const payments = useSelector(
    (state) => state.admin.payments?.data?.payments || []
  );
  const totalPaymentData = useSelector(
    (state) => state.admin.payments?.data?.totalPayments || 0
  );

  useEffect(() => {
    setLoading(true);
    const b = {
      currentPage,
      filter,
    };
    dispatch(fetchPaymentList(b)).then(() => {
      setLoading(false);
    });
  }, [dispatch, currentPage, filter]);

  const [error, setError] = useState("");
  const handlePageChange = (event) => {
    const selectedPage = Number(event.target.value);

    if (selectedPage > totalPages) {
      setError(`Maximum value must be ${totalPages}`);
      // setCurrentPage(totalPages);
      return;
    }
    setCurrentPage(selectedPage);
    setError("");
  };
  const totalPages = Math.ceil(totalPaymentData / itemsPerPage);

  return (
    <>
      <Layout>
        <div className="min-h-screen w-full  px-4 py-4">
          <section className="pt-1 grid grid-cols-2 items-center">
            <h1 className="text-xl font-bold text-white">
              {translations.payment.payments}
              <small className="text-2xl font-semibold text-gray-600"> |</small>
              <small className="font-normal text-gray-600">
                {" "}
                {translations.payment.paymentsManagement}
              </small>
            </h1>

            <div className="text-md text-white flex items-center justify-end space-x-1 ">
              <div className="rounded-full bg-[#5A189A] py-2 px-3">
                <Link
                  to="/"
                  className=" text-white  no-underline cursor-pointer"
                >
                  {translations.payment.dashboard}
                </Link>
                <span className="mx-1">/</span>
                <span className="text-green-300 ">
                  {translations.payment.payments}
                </span>
              </div>
            </div>
          </section>
          <div className="p-4 w-full bg-gray-800 shadow-xl rounded mt-5">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-2xl font-semibold text-white">
                    {translations.payment.paymentsList}
                  </h2>
                  <div className="flex items-center">
                    <label htmlFor="payment-status" className="text-white px-2">
                      {translations.payment.filterByStatus} :
                    </label>
                    <div className="relative">
                      <select
                        id="payment-status"
                        className="bg-gray-700 text-white rounded ps-2 pe-5 py-2 focus:outline-none w-full appearance-none"
                        value={filter}
                        onChange={(e) => {
                          const value =
                            e.target.value === "all"
                              ? "all"
                              : Number(e.target.value);
                          setFilter(value);
                          setCurrentPage(1);
                        }}
                      >
                        <option value="all">{translations.payment.all}</option>
                        <option value="11">{translations.payment.paid}</option>
                        <option value="12">
                          {translations.payment.unpaid}
                        </option>
                      </select>

                      <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                        <svg
                          className="w-4 h-4 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                {payments.length === 0 ? (
                  <div className="flex h-64 items-center justify-center text-gray-500 dark:text-gray-400">
                    <p className="text-xl">{translations.payment.noData}</p>
                  </div>
                ) : (
                  <>
                    <div className="grid  md:grid lg:grid  overflow-x-auto ">
                      <table className="min-w-full text-white shadow-md text-center  p-2">
                        <thead className="bg-[#5A189A] text-white text-md text-center">
                          <tr>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.payment.userName}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.payment.businessName}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.payment.staffName}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.payment.paymentMethod}
                            </th>

                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.payment.amount}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.payment.status}
                            </th>
                            <th className=" px-3 py-3 whitespace-nowrap">
                              {translations.payment.createdAt}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-600 ">
                          {payments.map((pay, index) => (
                            <tr
                              key={index}
                              // onClick={() => handleRowClick(pay._id)}
                              className={` text-center mb-3`}
                            >
                              <td className="px-3 py-3">
                                {pay?.user_id?.name}
                              </td>
                              <td className="px-3 py-3">
                                {pay?.salon_id?.business_name}
                              </td>
                              <td className="px-3 py-3">
                                {pay?.staff_id?.name}
                              </td>
                              <td className="px-3 py-3">
                                {pay.payment_method === 21
                                  ? "Cash"
                                  : pay.payment_method === 22
                                  ? "Card"
                                  : "Wallet"}
                              </td>

                              <td className="px-3 py-3  whitespace-nowrap">
                                {pay.total_amount}
                              </td>
                              <td className="px-4 py-3 font-semibold ">
                                <p
                                  className={`rounded-full px-3.5 mt-3 text-body-sm font-medium capitalize ${
                                    pay.payment_status === 12
                                      ? "bg-[#D34053]/[0.08] text-[#D34053]"
                                      : "bg-[#D34053]/[0.08] text-green-400"
                                  }`}
                                >
                                  {pay.payment_status === 11
                                    ? translations.payment.paid
                                    : translations.payment.unpaid}
                                </p>
                              </td>
                              <td className="px-4 py-3">
                                {new Date(pay.createdAt).toLocaleDateString()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination Controls */}
                    <div className="mt-4 flex justify-between text-white">
                      <svg
                        className={`${
                          currentPage === 1
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        width={24}
                        height={24}
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        aria-disabled={currentPage === 1}
                      >
                        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                      </svg>
                      <span>
                        {translations.payment.page}
                        {totalPages > 1 ? (
                          <input
                            type="number"
                            name=""
                            id="pagination-jump"
                            className={
                              error
                                ? `mx-2 rounded-md border  ps-1 border-red  bg-gray-800 text-white shadow-card focus:border-primary`
                                : `mx-2 rounded-md border border-gray-300 ps-1  bg-gray-800 text-white shadow-card focus:border-primary`
                            }
                            min={1}
                            max={totalPages}
                            defaultValue={currentPage}
                            onChange={(e) => e.target.value}
                            onBlur={(e) => handlePageChange(e)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handlePageChange(e);
                              }
                            }}
                          />
                        ) : (
                          <span className="mx-1">{currentPage}</span>
                        )}
                        {translations.payment.of} {totalPages}
                      </span>
                      <svg
                        className={`${
                          currentPage === totalPages
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 320 512"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        aria-disabled={currentPage === totalPages}
                      >
                        <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                      </svg>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Payment;
